import { HostedScriptsRolloutResource } from "client/resources/hostedScriptsRolloutResource";

// Keyed by reef id, holding one rollout per cluster of that reef.
export type ReefRollouts = Map<string, HostedScriptsRolloutResource[]>;

// A retry leaves more than one event for a cluster at a version, and only the last says where it
// ended up, so the grid is built from the latest per cluster.
export function latestRolloutsByVersionAndReef(rollouts: HostedScriptsRolloutResource[]): Map<string, ReefRollouts> {
    const latestPerCluster = new Map<string, HostedScriptsRolloutResource>();
    for (const rollout of rollouts) {
        const key = [rollout.Version, rollout.ReefId, rollout.KubernetesClusterName].join(" ");
        const existing = latestPerCluster.get(key);
        if (!existing || existing.StartedAt < rollout.StartedAt) {
            latestPerCluster.set(key, rollout);
        }
    }

    const grid = new Map<string, ReefRollouts>();
    for (const rollout of latestPerCluster.values()) {
        let reefs = grid.get(rollout.Version);
        if (!reefs) {
            grid.set(rollout.Version, reefs = new Map());
        }
        const forReef = reefs.get(rollout.ReefId);
        if (forReef) {
            forReef.push(rollout);
        } else {
            reefs.set(rollout.ReefId, [rollout]);
        }
    }
    return grid;
}
